import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { UsersContainer } from '../../components/users/UsersContainer';

const UsersPage: React.FC = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.isSuperuser && !me?.role?.changeUsersProfile) navigate('/');
  }, [me, me?.isSuperuser, me?.role?.changeUsersProfile, navigate])

  return (
    <Box>
      <UsersContainer />
    </Box>
  );
};

export default UsersPage;
